(() => {
  const SWIPE_THRESHOLD = 50;
  const MOBILE_BREAKPOINT = 749;

  function initCFLightboxSwipe() {
    document.querySelectorAll('product-modal').forEach((modal) => {
      if (modal.dataset.cfSwipeReady === 'true') return;

      const content = modal.querySelector('.product-media-modal__content');

      if (!content) return;

      modal.dataset.cfSwipeReady = 'true';

      let startX = 0;
      let startY = 0;

      function getMediaItems() {
        return Array.from(
          content.querySelectorAll('[data-media-id]')
        );
      }

      function getActiveIndex(items) {
        const index = items.findIndex((item) =>
          item.classList.contains('active')
        );

        return index >= 0 ? index : 0;
      }

      function showMedia(index) {
        const items = getMediaItems();

        if (!items.length) return;

        /* Loop continuously */
        if (index < 0) index = items.length - 1;
        if (index >= items.length) index = 0;

        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }

        items.forEach((item, itemIndex) => {
          const isActive = itemIndex === index;

          item.classList.toggle('active', isActive);
          item.setAttribute(
            'aria-hidden',
            isActive ? 'false' : 'true'
          );
        });

        const activeItem = items[index];

        /*
         * Load video content only when selected.
         */
        if (
          activeItem &&
          activeItem.nodeName === 'DEFERRED-MEDIA' &&
          typeof activeItem.loadContent === 'function'
        ) {
          activeItem.loadContent();
        }

        /*
         * Small visual transition.
         */
        if (activeItem && activeItem.animate) {
          activeItem.animate(
            [
              {
                opacity: 0.55,
                transform: 'translateX(10px)'
              },
              {
                opacity: 1,
                transform: 'translateX(0)'
              }
            ],
            {
              duration: 180,
              easing: 'ease-out'
            }
          );
        }
      }

      content.addEventListener(
        'touchstart',
        (event) => {
          if (window.innerWidth > MOBILE_BREAKPOINT) return;
          if (!modal.hasAttribute('open')) return;
          if (event.touches.length !== 1) return;

          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        },
        { passive: true }
      );

      content.addEventListener(
        'touchend',
        (event) => {
          if (window.innerWidth > MOBILE_BREAKPOINT) return;
          if (!modal.hasAttribute('open')) return;
          if (!event.changedTouches.length) return;

          const endX = event.changedTouches[0].clientX;
          const endY = event.changedTouches[0].clientY;

          const deltaX = endX - startX;
          const deltaY = endY - startY;

          /*
           * Ignore small movements and normal vertical scrolling.
           */
          if (Math.abs(deltaX) < SWIPE_THRESHOLD) return;

          if (Math.abs(deltaX) <= Math.abs(deltaY)) return;

          const items = getMediaItems();

          if (!items.length) return;

          const currentIndex = getActiveIndex(items);

          /*
           * Swipe left = next photo
           * Swipe right = previous photo
           */
          if (deltaX < 0) {
            showMedia(currentIndex + 1);
          } else {
            showMedia(currentIndex - 1);
          }
        },
        { passive: true }
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initCFLightboxSwipe
    );
  } else {
    initCFLightboxSwipe();
  }

  document.addEventListener(
    'shopify:section:load',
    initCFLightboxSwipe
  );
})();